import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Spring } from 'react-spring/renderprops';



function Cart({ items }) {


    console.log(items);
    const count = items.reduce((result, item) => result + item.qty, 0);
    const subTotal = items.reduce((result, item) => result + (item.unitPrice * item.qty), 0);

    if (items.length == 0) return null;
    return (
        <Spring
            from={{ opacity: 0, }}
            to={{ opacity: 1, }}
            leave={{ opacity: 0, }}
        >
            {props => <div><div className="float-cart float-cart--open" style={props} >
                <a className="text-white" href="/cart">
                    <span>{count} Items</span><span className="pl-5 pr-5">&nbsp;|&nbsp;</span><span>{subTotal}</span><span className="pull-right">View Cart <i className="si si-basket"></i></span>
                    <canvas height="0" width="0" ></canvas>
                </a>
            </div></div>}
        </Spring>

    )
}


Cart.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object)
}

const mapStateToProps = (state) => ({
    items: state.cart.items
})

export default connect(mapStateToProps, null)(Cart)
